import { createContext, useContext } from "react";

import { MessageBoxContextType } from "../types";

export const MessageBoxContext =
  // @ts-ignore
  createContext<MessageBoxContextType>();

export const useMessageBoxContext = () => useContext(MessageBoxContext);
